// import { PropertyLayoutsComponent } from './property/property-layouts/property-layouts.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortalLayoutsComponent } from './portal/portal-layouts/portal-layouts.component'
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { EmbLayoutsComponent } from './emb/emb-layouts/emb-layouts.component';
import { HrmsLayoutsComponent } from './hrms/hrms-layouts/hrms-layouts.component';
import { AdminLayoutsComponent } from './admin/admin-layouts/admin-layouts.component';
import { MdLayoutsComponent } from './md/md-layouts/md-layouts.component';
import { VmsLayoutComponent } from './vms/vms-layout/vms-layout.component';
import { AccountsLayoutsComponent } from './accounts/accounts-layouts/accounts-layouts.component';
import { RouteResolver } from './resolvers/route.resover'
import { PetLayoutComponent } from './pet/pet-layout/pet-layout/pet-layout.component';
import { PropertyLayoutsComponent } from './property/property-layouts/property-layouts.component';
import { NocLayoutComponent } from './NOC/noc-layout/noc-layout.component';
import { NocLayoutModule } from './NOC/noc-layout/noc-layout.module';
import { NocViewComponent } from './NOC/noc-view/noc-view.component';
import { KlmLayoutModule } from './klm/klm-layouts/klm-layout.module';
import { KlmLayoutsComponent } from './klm/klm-layouts/klm-layouts.component';
import { AdvertisementLayoutComponent } from './advertisement/advertisement-layout/advertisement-layout.component';
import { CaseLayoutsModule } from './CASE/case-layouts/case-layouts.module';
import { CaseLayoutsComponent } from './CASE/case-layouts/case-layouts.component';


const routes: Routes = [
  // ************************************SIMRAN CODE START*********************************
  { path: "", component: PortalLayoutsComponent, loadChildren: () => import('./portal/portal-layouts/portal-layouts.module').then(m => m.PortalLayoutsModule) },
  { path: "solution-admin", component: AdminLayoutsComponent, loadChildren: () => import('./admin/admin-layouts/admin-layouts.module').then(m => m.AdminLayoutsModule) },
  { path: "md", component: MdLayoutsComponent, loadChildren: () => import('./md/md-layouts/md-layouts.module').then(m => m.MdLayoutsModule) },
  { path: "hrms", component: HrmsLayoutsComponent, loadChildren: () => import('./hrms/hrms-layouts/hrms-layouts.module').then(m => m.HrmsLayoutsModule) },
  { path: "emb", component: EmbLayoutsComponent, loadChildren: () => import('./emb/emb-layouts/emb-layouts.module').then(m => m.EmbLayoutsModule) },
  { path: "accounts", component: AccountsLayoutsComponent, loadChildren: () => import('./accounts/accounts-layouts/accounts-layouts.module').then(m => m.AccountsLayoutsModule) },
  { path: "vms", component: VmsLayoutComponent, loadChildren: () => import('./vms/vms-layout/vms-layout.module').then(m => m.VmsLayoutModule) },
  { path: "advertisement", component: AdvertisementLayoutComponent, loadChildren: () => import('./advertisement/advertisement-layout/advertisement-layout.module').then(m => m.AdvertisementLayoutModule) },
  { path: "pet", component: PetLayoutComponent, loadChildren: () => import('./pet/pet-layout/pet-layout/pet-layout.module').then(m => m.PetLayoutModule) },
  { path: "property", component: PropertyLayoutsComponent, loadChildren: () => import('./property/property-layouts/property-layouts.module').then(m => m.PropertyLayoutsModule) },
  { path: "NOC", component: NocLayoutComponent, loadChildren: () => import('./NOC/noc-layout/noc-layout.module').then(m => NocLayoutModule) },
  { path: "hrms", component: HrmsLayoutsComponent, loadChildren: () => import('./hrms/hrms-layouts/hrms-layouts.module').then(m => m.HrmsLayoutsModule) },
  { path: "KALYANMANDAP", component: KlmLayoutsComponent, loadChildren: () => import('./klm/klm-layouts/klm-layout.module').then(m => KlmLayoutModule) },
  { path: "case", component: CaseLayoutsComponent, loadChildren: () => import('./CASE/case-layouts/case-layouts.module').then(m => m.CaseLayoutsModule) },

  // **************************************SIMRAN CODE END*************************************
  {
    "path": "login",
    "component": SigninComponent
  },
  {
    "path": "register",
    "component": SignupComponent
  },
  {
    "path": "noc-view",
    "component": NocViewComponent
  },
  {
    "path": "**",
    "redirectTo": "error_404",
    "pathMatch": "full"
  },
  {
    'path': '', 'redirectTo': 'index', 'pathMatch': 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [RouteResolver]
})
export class AppRoutingModule { }
